import { AfterViewInit, ChangeDetectorRef, Component, input, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ActiveForms, Form, AvailableForm, Client } from '../../../../models/client';
import { ClientService } from '../../../../services/client-service';
import { FormTypeTableColumns, TableColumn } from '../../../../services/common-service';
import { DatatableComponent } from '../../../../utils/datatable-component/datatable-component';

// translation service
import { TranslatePipe } from '@ngx-translate/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component( {
  selector: 'app-form-items-component',
  imports: [
    RouterLink,
    DatatableComponent, MatSelectModule, MatFormFieldModule,
    MatIconModule, MatButtonModule,
    TranslatePipe
  ],
  templateUrl: './form-items-component.html',
  styleUrl: './form-items-component.css',
} )
export class FormItemsComponent implements OnInit, AfterViewInit
{
  
  constructor(
    private _clientService: ClientService,
    private _cdr: ChangeDetectorRef,
  ) { }

  clientId = input.required<string>();
  addEnabled: boolean = true;
  readOnly: boolean = false;
  client: Client | undefined;
  legend: string = 'Pathways'
  data: ActiveForms | undefined;
  formTypes: string[] = ['P'];
  forms: Record<string, Form[]> | null = null;
  formsTypeColumns = FormTypeTableColumns;
  availableForms: AvailableForm[] | null = null;
  filteredAvailableForms = ( type: string ): AvailableForm[] =>
  {
    return this.availableForms ? this.availableForms.filter( f => f.formPct === type ) : [];
  };

  selectedForm: AvailableForm | null = null;

  async ngOnInit(): Promise<void>
  {

  }

  async ngAfterViewInit(): Promise<void>
  {
    this.client = await this._clientService.getClient( this.clientId() );
    // this.data = await this._clientService.getActiveForms( this.clientId() );
    this.availableForms = await this._clientService.getAvailableForms( this.clientId() ) || [];
    this._cdr.detectChanges();
  }

  getDataSource( type: string ): Form[]
  {
    let dataSource: Form[] = [];
    if ( this.data && this.data.all )
    {
      dataSource = this.data.all[type] || [];
    }
    return dataSource;
  }

  getDisplayedColumns( type: string ): TableColumn[]
  {
    const displayedColumns: TableColumn[] = this.formsTypeColumns[type].DefaultColumns || [];
    return displayedColumns;
  }

}
